module.exports = __webpack_public_path__ + "img/2025big4.2075c099.jpg";